import { useContext, useEffect } from "react";
import { BackButton } from "../../components/BackButton";
import { Step } from "../../models/Step";
import { ApplicationFormStateContext } from "../../state/applicationFormState";
import { saveStateRemote } from "../../utils/api";
import { trackEvent } from "../../utils/gtm";
import { scrollToTopOfContent } from "../../utils/scroll";
import { useNavigate } from "react-router-dom";
import YesNo from "../../components/YesNo";

const HasCoApplicantStep: React.FunctionComponent = () => {
  const [state, dispatch] = useContext(ApplicationFormStateContext);
  const navigate = useNavigate();


  useEffect(() => {
    trackEvent({eventName: 'step_load', data: { step: 'HasCoApplicant' } });
    dispatch({ type: 'set_step', step: Step.HasCoApplicant });
    scrollToTopOfContent();

    const saveState = async () => { await saveStateRemote(state); }
    saveState();
  }, []);
  
  const handleNo = () => {
    dispatch({ 
      type: 'set_coApplicant', 
      coApplicantInfoGovermentId: undefined, 
      coApplicantInfoMobile: undefined, 
      coApplicantInfoEmail: undefined, 
      coApplicantInfoEmploymentType: undefined, 
      coApplicantInfoEmploymentYear: undefined,
    });

    dispatch({ 
      type: 'set_coApplicantIncome', 
      coApplicantMonthlyIncomeGross: undefined,
      coApplicantMonthlyIncomeNet: undefined
    });

    navigate('/boligform');
  };

  return (
    <>
      <h2>Medansøger</h2>

      <h3>
        Vil du tilføje en medansøger?<br />
        OBS! Det anbefales at tilføje en medansøger, da det øger sandsynligheden for at få bevilliget en kredit, når I er flere om at låne penge.
      </h3>

      <div className="mt-5">
        <YesNo  
          onYes={() => navigate('/medansoeger')}
          onNo={handleNo}
          >
        </YesNo>
      </div>

      <div className="container-btn">
        <BackButton />
      </div>
    </>
  );
};

export default HasCoApplicantStep;
